module.exports = __webpack_public_path__ + "fonts/chevron-up.svg";